import { createFileRoute } from '@tanstack/react-router'

import { TwilioRepliesScreen } from './-components/twilio-replies-screen.tsx'

export const Route = createFileRoute('/cs-tools/twilio-replies')({
  component: TwilioRepliesScreen
})
